<template>
  <main-large-dialog
    v-bind="$props"
    :is-visible.sync="computedIsVisible"
    :is-valid="isFormValid"
    :loading="isLoading"
    :title="$i18n.t('dialog.title.addKomadresOrder')"
    :no-paddings-x="true"
    dialog-width="25%"
    agree-text="dialog.agreeAdd"
    header-shadow
    @agree="handleKomadresOrderAdding"
    @modalClosed="clearColums"
  >
    <template #body>
      <v-row class="flex-column" no-gutters>
        <v-row v-for="(input, idx) in inputs" :key="idx" no-gutters>
          <v-col cols="8" class="ml-10">
            <data-input v-model="payload[input.name]" v-bind="input" />
          </v-col>
        </v-row>
      </v-row>
    </template>
  </main-large-dialog>
</template>

<script>
import { get, call } from 'vuex-pathify';

import DataInput from '@/components/DataInput';

export default {
  name: 'QuickKomadresOrder',
  components: {
    DataInput,
    MainLargeDialog: () => import('@/components/MainLargeDialog'),
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    layerId: {
      type: [Number, String],
      default: null,
    },
    selectedFeatures: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    isLoading: false,
    payload: {
      type: '',
      description: '',
    },
  }),
  computed: {
    komadresDataSource: get('layers/metadata@:komadresDataSourceName'),
    komadresDataSourceName: get('admin/modulesMapping@komadres_orders.komadres_orders_datasource'),
    komadresTypeAttribute: get('admin/modulesMapping@komadres_orders.order_type_attribute'),
    komadresDescriptionAttribute: get('admin/modulesMapping@komadres_orders.order_description_attribute'),
    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    inputs() {
      return [
        {
          name: 'type',
          dataType: { name: 'text' },
          label: this.getAttributeLabelName(this.komadresTypeAttribute),
          hideDetails: true,
          clearable: true,
        },
        {
          name: 'description',
          dataType: { name: 'textarea' },
          label: this.getAttributeLabelName(this.komadresDescriptionAttribute),
          hideDetails: true,
          clearable: true,
          autoGrow: true,
          dense: true,
          rows: '1',
          class: 'mt-5',
        },
      ];
    },
    isFormValid() {
      return Object.values(this.payload).every(el => el);
    },
  },
  beforeDestroy() {
    this.clearColums();
  },
  methods: {
    addKomadresOrder: call('externalSystems/addKomadresOrder'),
    async handleKomadresOrderAdding() {
      this.isLoading = true;
      try {
        const payload = {
          ...this.payload,
          layer: this.layerId,
          ids: this.selectedFeatures,
        };
        await this.addKomadresOrder(payload);
      } catch (error) {
        console.log('  error', error);
      } finally {
        this.isLoading = false;
        this.computedIsVisible = false;
        this.clearColums();
      }
    },
    getAttributeLabelName(name) {
      return this.komadresDataSource?.attributes_schema.attributes.find(attr => attr.name === name).verbose_name;
    },
    clearColums() {
      this.payload = {
        description: '',
        type: '',
      };
    },
  },
};
</script>
